import ZkDepartmentSaveOrUpdate from './src/main.vue'
ZkDepartmentSaveOrUpdate.install = function (Vue) {
  Vue.component(ZkDepartmentSaveOrUpdate.name, ZkDepartmentSaveOrUpdate)
}

export default ZkDepartmentSaveOrUpdate



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/departmentSaveOrUpdate/index.js